import { Habit, RepeatingTask, Timestamp } from '@griply/types';

import { isScheduleTaskCompletedForDate } from './is-schedule-task-completed-for-date';

// Today's "Completed" bucket for schedule tasks: reached their target today and are not hidden from Today.
export const getTodaysCompletedScheduleTasks = <
  T extends Habit | RepeatingTask,
>(
  tasks: T[],
  today: Timestamp,
): T[] =>
  tasks.filter(
    (task) => !task.hideOnTodo && isScheduleTaskCompletedForDate(task, today),
  );
